import { client } from "@/config/client"

interface UpdateDeckParams {
  deckId: string
  body: {
    flashcards: {
      id: string
      question: string
      answer: string
    }[]
  }
}

export default function updateDeck({ deckId, body }: UpdateDeckParams) {
  return client.put(`/v1/flashcards/decks/${deckId}`, body)
}
